import { createContext, useContext } from 'react';
import type { ApiFormulaires } from './api';
import { apiFormulairesAdmin } from '../services/formulairesServices';

// API des formulaires joints utilisée par FormulairesDossier, JoindreFormulaireDialog et NouveauDossierDialog.
// Défaut = admin (/formulaires, sans auth) : l'admin standard n'a rien à fournir. L'admin Legrand enveloppe ses écrans
// dans <ApiFormulairesProvider value={apiFormulairesLegrand}>.
const ApiFormulairesContext = createContext<ApiFormulaires>(apiFormulairesAdmin);

export const ApiFormulairesProvider = ApiFormulairesContext.Provider;

export const useApiFormulaires = (): ApiFormulaires => useContext(ApiFormulairesContext);
